module.exports = __webpack_public_path__ + "static/img-01.57324e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/karesansui/img-01.png
// module id = 90
// module chunks = 65743467281970 88197199937824 213720915766396